import React from 'react'
import { Tooltip } from 'components/elements/Tooltip'
import { labelStyle } from './Label.css'
import { View } from 'reshaped/bundle'

interface Props {
	tooltipText?: string
	label: string | JSX.Element
	htmlFor: string
}

export const Label: React.FC<React.PropsWithChildren<Props>> = ({ tooltipText, label, htmlFor }) => {
	return (
		<View>
			<label className={labelStyle} htmlFor={htmlFor}>
				{label}{' '}
			</label>
			{tooltipText && <Tooltip>{tooltipText}</Tooltip>}
		</View>
	)
}
